export default {
  name: 'Repodas',
  subTitle: 'Instant Reports from Video - Making Field Reporting Simple',
  roles: {
    owner: 'Owner',
    member: 'Member',
    reporter: 'Reporter',
  },
  teamContext: {
    switchConfirmTitle: 'Switch Team?',
    switchingTo: 'Switching to',
    yourRole: 'Your Role',
    cancel: 'Cancel',
    switch: 'Switch',
    uploadConfirmTitle: 'Upload Report',
    uploadTo: 'Upload to Team',
    changeTeam: 'Change Team',
    upload: 'Upload',
  },
  layout: {
    main: {
      profile: 'Account',
      greeting: 'Hello, {name}',
      currentTeam: 'Current team',
      switchTeams: {
        title: 'Switch teams',
        joinNewTeam: 'Join a new team...',
      },
      joinNewTeam: {
        title: 'Join New Team',
        description: 'You can join new team if you have an invitation code.',
        invitationCodePlaceholder: 'Enter Invitation Code',
        btnJoin: 'Join',
        notifySuccess: 'You have successfully joined the team.',
        errors: {
          invalidCode: 'Invalid invitation code. Please enter a valid code.',
          expiredCode: 'Invitation code has expired.',
          alreadyAccepted: 'This invitation code has already been used.',
          wrongEmail: 'This invitation is not addressed to your email.',
          alreadyMember: 'You are already a member of this team.',
        },
      },
      menu: {
        videoList: 'Report List',
        advancedSearch: 'Advanced Search',
        settings: 'User Settings',
        profile: 'Profile',
        subscription: 'Subscription',
        apiKey: 'API Key',
        history: 'History',
        billing: 'Billing',
      },
      footer: {
        privacyPolicy: 'Privacy Policy',
        termsOfUse: 'Terms of Use',
        logout: 'Log out',
      },
    },
  },
  general: {
    copyToClipboard: 'Copy to clipboard',
    copied: 'Copied!',
    quota: {
      minsUsed: '{used}/{total} mins used',
      secsUsed: '{used}/{total} secs used',
      secPerMinsUsed: '{used} secs / {total} mins used',
      minPerMinsUsed: '{used} mins / {total} mins used',
      uploadableLength: 'Uploadable video length',
      title: 'Video Report Quota',
      loading: 'Loading quota...',
      used: 'Used',
      remaining: 'Remaining',
      total: 'Total',
      warning: {
        approaching: 'You are approaching your quota limit. Consider upgrading your plan.',
        critical: 'Your quota is almost full. You may not be able to upload more videos soon.',
        exceeded: 'Your quota has been exceeded. Please upgrade your plan to continue uploading.',
      },
      freeTrialExpired: 'Free trial ended',
      freeTrialExpiresOn: 'Free trial expires: {date}',
      freeTrialExpiresInDays: 'Free trial ends in {days} days',
      upgradeNow: 'Upgrade Now',
    },
  },
  languages: {
    en: 'English',
    zh: 'Chinese',
    ja: 'Japanese',
    de: 'German',
    fr: 'French',
    es: 'Spanish',
    ko: 'Korean',
    ar: 'Arabic',
    ru: 'Russian',
    nl: 'Dutch',
    it: 'Italian',
    pl: 'Polish',
    pt: 'Portuguese',
    vi: 'Vietnamese',
    th: 'Thai',
    id: 'Indonesian',
    unknown: 'Unknown',
  },
  modal: {
    error: 'Error',
    close: 'Close',
    cancel: 'Cancel',
    confirm: 'Confirm',
    submit: 'Submit',
    save: 'Save',
    delete: 'Delete',
    ok: 'OK',
    back: 'Back',
  },
  login: {
    title: 'Login',
    subTitle: 'Welcome back!',
    email: 'Email Address',
    password: 'Password',
    forgotPasswordLink: 'Forgot password?',
    btnLogin: 'Sign in',
    doNotHaveAccount: "Don't have an account?",
    signUpWithEmail: 'Sign up',
    or: 'OR',
    signInWithGoogle: 'Sign in with Google',
    termOfUse: 'Term of Use',
    privacyPolicy: 'Privacy Policy',
    errorLogin: {
      title: 'Error Login Failed',
      first: 'The email or password seems to be incorrect. Please enter it again.',
      second: '※ Please ensure that Caps Lock is off and enter the information correctly.',
    },
  },
  forgotPassword: {
    title: 'Forgot Password',
    description: {
      first:
        'If you have forgotten your password, we will send a URL to the page where you can register a new password to the email address you registered.',
      second: 'Please enter your email address and click the "Send" button.',
    },
    email: 'Email',
    login: 'Back to Login',
    btnSend: 'Send',
    titleMessage: 'Check your email',
    successForgotPassword:
      'If there is an account associated with this email, you will receive instructions on how to reset your password.',
  },
  resetPassword: {
    title: 'Reset Password',
    password: 'Password',
    confirmationPassword: 'Password confirmation',
    login: 'Back to Login',
    btnSubmit: 'Submit',
    titleMessage: 'Reset Link Invalid',
    successResetPassword: 'Your password has been reset. Please try logging in',
    error401ResetPassword:
      'This link is invalid or has expired. Please reset your password again by navigating to Login > Forgot Password.',
  },
  signup: {
    signInWithGoogle: 'Continue with Google',
    and: 'and',
    or: 'OR',
    title: 'Create an Account',
    btnSubmit: 'Continue',
    alreadyHaveAccount: 'Already have an account?',
    login: 'Log in',
    step1: {
      subTitle: 'Enter your Email Address to create an account',
      email: 'Email Address',
      descriptionAgreePolicyAndTerms: 'Please agree to our Privacy Policy and Terms of Service.',
      checkboxAgreePolicyAndTerms: "I have read and agree to repodas's",
      privacyPolicy: 'Privacy Policy',
      termsOfUse: 'Terms of Use',
      agreementPostfix: '',
      invitationSection: {
        title: 'Do you have an invitation code?',
        placeholder: 'Enter invitation code (optional)',
        verify: 'Verify',
        verified: 'Invitation code verified',
        teamName: 'Team Name',
        yourRole: 'Your Role',
      },
      errors: {
        emailIsExisting: 'This email address is already registered. Please use a different email address.',
        emailIsDeleted: 'This email address is not available.',
        invalidInvitationCode: 'Invalid invitation code',
        expiredInvitationCode: 'Invitation code has expired',
        alreadyAccepted: 'This invitation code has already been used',
        mustAgreeToTerms: 'Please agree to the Privacy Policy and Terms of Use.',
      },
    },
    step2: {
      subTitle: 'Set a password for repodas to continue',
      password: 'Password',
    },
    step3: {
      title: 'Verification Code',
      subTitle: {
        first: 'We sent an account verification code to ',
        second: 'Please check your email in order to verify your account and continue',
      },
      verificationCode: 'Verification Code:',
      didNotGetEmail: "Didn't get the email?",
      resendCode: 'Resend Code',
      orDoubleCheckYourEmailAddress: 'or double check your email address',
      successResendCode: {
        titleMessage: 'Check your email',
        bodyMessage: 'Please double-check your email address and also check your spam folder.',
      },
      errors: {
        tooManyRequest: "You've requested a code recently. Please wait up to 5 minutes before requesting a new one.",
        wrongVerificationCode: 'Wrong verification code. Please try again.',
        verificationCodeExpired: 'Verification code has expired. Please request a new code.',
      },
    },
  },
  userProfile: {
    title: 'Update Information',
    subTitle: 'Please enter user info to complete creating account for repodas',
    name: 'Name',
    companyOrganizationName: 'Company / Organization Name',
    numberOfEmployees: {
      title: 'Number of Employees',
      placeholder: '--- Please select ---',
    },
    yourRole: {
      title: 'Your Role',
      placeholder: '--- Please select ---',
      EXECUTIVE_CXO: 'Executive / CXO',
      MANAGER_TEAM_LEAD: 'Manager / Team Lead',
      STAFF_INDIVIDUAL_CONTRIBUTOR: 'Staff / Individual Contributor',
      ENGINEER_DESIGNER_RESEARCHER: 'Engineer / Designer / Researcher',
      STUDENT: 'Student',
      OTHER: 'Other',
    },
    btnContinue: 'Continue',
  },
  userTeam: {
    title: 'Join a Team',
    subTitle: 'Please join a team if you have an invitation code',
    continueWithoutTeam: 'Continue without a team',
    namesTeam: "'s Team",
    joinTeam: 'Join an existing team',
    joinTeamDescription: 'You can join an existing team if you have an invitation code',
    joinTeamPlaceholder: 'Invitation Code',
    btnContinue: 'Continue',
    joiningTeam: 'Joining Team',
    creatingTeam: 'Creating Your Team',
    pleaseWait: 'Please wait...',
  },
  settingsProfile: {
    title: 'Profile',
    userInformation: {
      sidebar: 'User Information',
      title: 'User Information',
      name: "User's Name",
      required: '*Required',
      companyName: 'Company/Organization',
      numberOfEmployees: 'Number of Employees',
      placeholder: '--- Please select ---',
      role: {
        title: 'Role',
        EXECUTIVE_CXO: 'Executive / CXO',
        MANAGER_TEAM_LEAD: 'Manager / Team Lead',
        STAFF_INDIVIDUAL_CONTRIBUTOR: 'Staff / Individual Contributor',
        ENGINEER_DESIGNER_RESEARCHER: 'Engineer / Designer / Researcher',
        STUDENT: 'Student',
        OTHER: 'Other',
      },
      btnCancel: 'Cancel',
      btnSave: 'Save',
      email: 'Email',
      manageByGoogle: 'Manage by Google',
    },
    teamMembers: {
      sidebar: 'Team & Members',
      title: 'Team & Members',
      teamName: 'Team Name',
      teamNamePlaceholder: 'Enter Team Name',
      btnSave: 'Save',
      yourRole: 'Your Role',
      members: 'Members',
      btnInviteNewMember: 'Invite New Member',
      inviteNewMemberToYourTeam: 'Invite New Member to Your Team',
      sendInvitation: 'Send invitation link to:',
      emailPlaceholder: 'Enter Email',
      selectRole: 'Select Role',
      roleDescription: {
        member: 'Can view all team reports and create new reports',
        reporter: 'Can only view and create their own reports',
      },
      orShareThisCodeTitle: 'Your invitation code is ready!',
      orShareThisCodeMessage: 'This code is valid only for the email address above:',
      btnSend: 'Send',
      btnSendAgain: 'Send Again',
      notify: {
        success: 'Update Team Name successfully.',
        error: 'Failed to send the invitation email. Please try again.',
        inviteSuccess: 'Invitation sent successfully.',
      },
      popup: {
        title: 'Permanently delete this Member?',
        btnCancel: 'Cancel',
        btnDelete: 'Delete',
      },
      roles: {
        owner: 'Owner',
        member: 'Member',
        reporter: 'Reporter',
      },
    },
    changeEmail: {
      sidebar: 'Change Email',
      title: 'Change Email',
      newEmail: 'New Email',
      newEmailPlaceholder: 'Enter New Email',
      newEmailConfirmPlaceholder: 'Enter New Email (Confirm)',
      currentPassword: 'Current Password',
      currentPasswordPlaceholder: 'Enter Current Password',
      confirm: 'Confirm',
      description: 'We will send verification code to your new Email address.',
      btnSubmit: 'Submit',
      notify: {
        success: 'Email changed successfully.',
        error: 'Failed to change email. Please try again.',
      },
      popup: {
        title: 'Verification Code',
        subTitle: {
          first: 'We sent an account verification code to ',
          second: 'Please check your email in order to verify your account and continue',
        },
        verificationCode: 'Verification Code:',
        didNotGetEmail: "Didn't get the email?",
        orDoubleCheckYourEmailAddress:
          'Please try again after some time, or check whether the email address you entered is correct.',
        otp: 'Enter OTP',
        btnChangeEmailAddress: 'Change Email Address',
        btnCancel: 'Cancel',
        resendCodeSuccess: 'Verification code resent successfully',
      },
    },
    changePassword: {
      sidebar: 'Change Password',
      title: 'Change Password',
      currentPassword: 'Current Password',
      currentPasswordPlaceholder: 'Enter Current Password',
      newPassword: 'New Password',
      newPasswordPlaceholder: 'Enter New Password',
      confirm: 'Confirm',
      newPasswordConfirmPlaceholder: 'Enter New Password (Confirm)',
      btnSave: 'Save',
      notify: {
        success: 'Password changed successfully.',
        error: 'Failed to change password. Please try again.',
      },
    },
    deleteAccount: {
      sidebar: 'Delete Account',
      title: 'Delete Account',
      dangerZone: 'Danger Zone',
      description:
        'Permanently remove your Personal Account and all of its contents from the platform. This action is not reversible, so please continue with caution.',
      btnDelete: 'Delete Account',
      popup: {
        title: 'Permanently delete this account?',
        warningText: 'Type your email address to proceed',
        email: 'Enter your email',
        btnCancel: 'Cancel',
        btnDelete: 'Delete',
        error: 'Please remove all other members from your teams before deleting your account.',
      },
    },
    logout: 'Logout',
  },
  subscription: {
    title: 'Subscription',
    plan: {
      title: 'Upgrade Options',
      selectPlan: 'Select a Plan',
      loading: 'Loading Plan options...',
      customerSessionError: 'Failed to get plan information. Please try again.',
      invoiceTitle: 'For those who prefer to pay by invoice',
      subscribeInvoice: 'Payment by Invoice',
      subscribe: 'Subscribe',
      interval: 'interval',
      invoiceSent: 'An invoice has been sent to your email address.',
      contactSalesTitle: 'Enterprise Plan',
      contactSales: 'Contact Sales Team',
      contactSalesDesc: 'Credit card / Invoice payment',
      enterprisePlanUpgradeNote:
        'If you wish to exceed your current usage limits, please feel free to contact our sales team.\nWe’ll be happy to provide a flexible solution tailored to your needs.',
      month: 'mo',
      year: 'yr',
      businessPlan: 'Business Plan',
      monthly: 'Monthly',
      yearly: 'Yearly',
      currentPlan: 'Current Plan',
      videoGenerationFree: '1-month free trial (up to {min} minutes of video upload)',
      videoGeneration: '{min}-min video/month',
      enterprisePRapi: 'API access',
      enterprisePRteam: 'Team management',
      enterprisePRdesc: 'Custom plans available - Contact us for your needs',
      noActivePlan: 'No active subscription plan',
      nextRenewal: 'Next renewal: ',
      autoCheckoutTitle: 'Ready to Subscribe?',
      autoCheckoutMessage:
        'You will be redirected to the payment page to complete your subscription to the Business Plan.',
      proceedToPayment: 'Go to Payment',
    },
    haveCoupon: 'Have a coupon code?',
    hideCoupon: 'Hide coupon',
    couponPlaceholder: 'Enter coupon code',
  },
  contactSales: {
    title: 'Contact Form',
    emailLabel: 'Email Address',
    emailPlaceholder: 'Enter your email address',
    inquiryLabel: 'Inquiry Details',
    inquiryPlaceholder: 'Please describe your inquiry or questions...',
    sendButton: 'Send',
    backToSubscription: 'Back to Subscription',
    formValidationError: 'Please fill in all required fields correctly.',
    inquirySent: 'Your inquiry has been sent successfully. We will get back to you soon.',
  },
  billing: {
    title: 'Billing',
    manageButton: 'Manage Billing',
    error: 'Failed to open billing portal.',
  },
  apiKey: {
    title: 'API Key',
    subTitle: 'Your API Key',
    copySuccess: 'Copied to clipboard',
    noKey: 'To start using repodas API, team owners must generate an API key.',
    generateButton: 'Generate API Key',
    generateSuccess: 'API key generated successfully',
    regenerateButton: 'Regenerate',
    regeneratePopupTitle: 'Regenerate API Key',
    regenerateConfirm: 'Are you sure you want to regenerate your API key? This will invalidate your existing key.',
    regenerateSuccess: 'API key regenerated successfully',
    generateError: 'Failed to generate API key. Please try again later.',
  },
  history: {
    title: 'History',
    range: 'Items {start}-{end} of {total}',
    loading: 'Loading history...',
    noHistory: 'No history found.',
    error: 'Failed to load history.',
    pages: ' pages',
    items: ' items',
    tabs: {
      appHistory: 'App History',
      apiHistory: 'API History',
    },
    table: {
      createdDatetime: 'Created Datetime',
      type: 'Type',
      name: 'Name',
      duration: 'Duration (mins)',
      creator: 'Creator',
    },
    startDate: 'Start Date',
    endDate: 'End Date',
    periodLabel: 'Date Range',
    separator: '–',
    displayButton: 'Show',
    dateError: 'Display period is not correct. End date must be on or after start date.',
    noData: 'No data found for the selected period.',
    types: {
      report_generation: 'Report generation',
    },
  },
  validation: {
    general: 'An error occurred. Please try again later.',
    invalid: 'Invalid value.',
    email: 'Please enter a valid email address.',
    required: 'This field is required.',
    min: 'Please enter at least {length} characters.',
    max: 'Please enter no more than {length} characters.',
    alphaNumeric: 'Please enter alphabetic and numeric characters only.',
    number: 'Please enter a number.',
    halfSizeLetter: 'Please enter half-width characters.',
    greaterOrEqual: 'Value must be greater than or equal to {value}.',
    confirmationPassword: 'Passwords do not match',
    confirmationEmail: 'Email do not match',
    match: 'Please enter alphanumeric characters only',
  },
  notification: {
    general: {
      unknownError: 'An error occurred. Please try again later.',
      fetchFailed: 'Failed to fetch {resource}. Please try again later.',
      createSuccess: '{resource} created successfully',
      createFailed: 'Failed to create {resource}. Please try again later.',
      createFailedWithZeroCapacity: 'Failed to create {resource} due to high traffic. Please try again later.',
      updateSuccess: '{resource} updated successfully',
      updateFailed: 'Failed to update {resource}. Please try again later.',
      deleteSuccess: '{resource} deleted successfully',
      deleteFailed: 'Failed to delete {resource}. Please try again later.',
    },
    resource: {
      video: 'Video',
      team: 'Team',
      member: 'Member',
      user_information: 'User Information',
      quota: 'Quota',
    },
  },
  errors: {
    errorGeneral: "We're having trouble processing your request right now. Please try again later.",
    quotaExceeded: 'You have reached your video generation limit. Please upgrade your plan.',
    freeTrialExpired: 'Your free trial has ended. Please upgrade your plan to continue.',
  },
  // Video feature translations
  videos: {
    dateGroup: {
      today: 'Today',
      yesterday: 'Yesterday',
    },
    title: 'Reports',
    searchByTags: 'Search by tags',
    searchPlaceholder: 'Search reports...',
    btnUpload: 'Create Report',
    btnRefresh: 'Refresh',
    inprogress: 'In Progress',
    processing: 'Processing...',
    processingFailed: 'Processing failed',
    noTitle: 'Untitled Report',
    noDescription: 'No description available',
    failed: 'Failed',
    uploadedAt: 'Uploaded at',
    workDate: 'Work date',
    btnRetry: 'Retry',
    btnDelete: 'Delete',
    messageConfirmDeletion: 'Are you sure you want to permanently remove this report?',
    uploadedBy: 'Reporter:',
    create: {
      title: 'Create Report',
      optionCamera: 'Record with Camera',
      optionCameraDesc: 'Start recording now',
      optionFile: 'Choose from Files',
      optionFileDesc: 'Upload video from device',
    },
    camera: {
      permissionDenied: 'Camera access is not allowed',
      notSupported: 'Your browser does not support camera recording',
      startRecording: 'Start Recording',
      stopRecording: 'Stop Recording',
      cancel: 'Cancel',
      retake: 'Retake',
      useVideo: 'Use this Video',
      recording: 'Recording',
      maxDurationWarning: 'Recording exceeds 10 minutes',
      preparing: 'Preparing camera...',
      switchCamera: 'Switch Camera',
    },
    upload: {
      title: 'Upload Video',
      textAboutVideo: 'Describe your video:',
      placeholderAboutVideo: 'Enter a description or context of the video.',
      textUploadImage: 'Upload an image of a person in the video:',
      personName: "Person's Name",
      placeholderPersonName: 'Enter the name of the person',
      textUploadImageFile: 'Upload',
      textDeleteImageFile: 'Delete',
      btnAddMore: 'Add More People',
      personError: 'Please add both the name and the image for this section.',
      imageSizeError: 'File size must not exceed 10MB',
      makeTrailer: 'Make trailer',
      textMakeTrailer: 'Trailer Creation Context:',
      placeholderMakeTrailer: 'Enter the context for generating a trailer',
      btnGoToNextStep: 'Next',
      btnCancel: 'Cancel',
      description: 'Drag & drop or click to choose files',
      maxSize: 'Formats: MP4, MOV, M4V, WebM (max 2GB)',
      btnUpload: 'Upload and Create Report',
      bthGoToPreviousStep: 'Back',
      maxSizeVideo: 'File size must not exceed 100MB',
      fileTooLarge: 'File is too large. Please select a file under 2GB.',
      largeFileWarning: 'Large files will be optimized on the server.',
      longDurationWarning: 'Videos over 10 minutes may take longer to process.',
      outputLanguage: 'Output Language',
      invalidFormat: 'Invalid file format. Please upload MP4, MOV, M4V, or WebM.',
    },
    btnViewMore: 'View More',
    btnViewLess: 'View Less',
  },
  videoDetail: {
    btnViewFrameImages: 'View All',
    btnSearch: 'Search Similar Video',
    btnSearchSimilarScenes: 'Search Similar Scenes',
    btnMakeTrailer: 'Make Trailer',
    textMakeTrailer: 'Trailer Creation Context:',
    placeholderMakeTrailer: 'Enter the context for generating a trailer',
    btnMakeReport: 'Make Report',
    textMakeReport: 'Report Creation Context:',
    placeholderMakeReport: 'Enter the context for generating a report',
    btnCancel: 'Cancel',
    filename: 'Filename:',
    workDate: 'Work Date:',
    length: 'Duration:',
    watchFullVideo: 'Watch Full Video',
    description: 'Description',
    tag: 'Tags',
    trailer: 'Trailer',
    report: 'Report',
    scenes: 'Scenes',
    scene: 'Scene',
    sceneDescription: 'Scene Description',
    frameImages: 'Frame Images',
    processingTrailer: 'Generating trailer...',
    processingReport: 'Generating report...',
    created: 'Created',
    notCreated: 'Not Created',
    btnRegenerate: 'Regenerate',
    watchTrailerVideo: 'Watch Trailer Video',
    openReport: 'Open Report',
    transcript: 'Transcript',
    original: 'Original',
    translated: 'Translated',
    keyActions: 'Key Actions',
    detectedTexts: 'Detected Text (OCR)',
    at: 'at',
    spokenLanguage: 'Spoken Language',
  },
  advancedSearch: {
    title: 'Advanced Search',
    sceneMode: {
      descriptionFromText: 'Description From',
      sceneText: 'Scene',
      fromText: 'from',
      noteText: 'Note: This scene will be excluded from the similar search results.',
    },
    videoMode: {
      summaryFromText: 'Summary From',
      noteText: 'Note: This video will be excluded from the similar search results.',
    },
    videos: 'Videos',
    scenes: 'Scenes',
    inputSearchPlaceholder: 'Describe an object, scene, or story you want to discover',
    descriptionError: 'The input length has reached the maximum limit of 1024 characters.',
    additionalFilters: 'Additional Filters',
    resetFilters: 'Reset Filters to Default',
    topKValue: 'Top Results Count',
    searchMethod: {
      title: 'Search Method',
      hybrid: 'Hybrid Search',
      semantic: 'Semantic Search',
      keyword: 'Keyword Search',
    },
    searchScenesFrom: {
      title: 'Search Scenes From',
      all: 'All Videos',
      current: 'This Video',
    },
    btnSearchSimilarVideo: 'Search Similar Videos',
    btnSearchSimilarScene: 'Search Similar Scenes',
    btnSearchRelevantVideo: 'Search Relevant Videos',
    btnSearchRelevantScene: 'Search Relevant Scenes',
  },
  similarVideo: {
    top10Picks: 'Top {k} Picks',
    filters: 'Filters:',
    searchVideos: 'Search Videos',
    searchScenes: 'Search Scenes',
    btnChange: 'Change',
    fromText: 'from',
    btnViewMore: 'View More',
    btnViewLess: 'View Less',
    similarityScore: 'Similarity Score:',
  },
  noSimilarVideo: {
    subTitleForVideo: 'No matching videos found.',
    subTitleForScene: 'No matching scenes found.',
    description: 'Try changing your criteria or filters.',
  },
  noVideo: {
    subTitle: 'Currently, there are no videos.',
    description: 'Please upload a video to use this feature.',
    noSearchResult: 'No matching videos found.',
  },
  popupMessage: {
    error: 'Something went wrong. Please try again!',
  },
};
